import React from "react";

const WelcomeVideo = () => {
  return (
    <iframe
      src="https://www.youtube.com/embed/Af4ZObi1rxs"
      title="animation"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen={true}
    ></iframe>
  );
};

export default WelcomeVideo;
